export const SET_LANGUAGE = "common/SET_LANGUAGE";
